import PropTypes from 'prop-types';
import React, { cloneElement, Children } from 'react';
import SubNavigationItem from "./sub-navigation-item";

var subNavigationPropTypes = function subNavigationPropTypes(propValue, key, componentName, location, propFullName) {
  if (propValue[key].type !== SubNavigationItem) return new Error("Invalid prop '".concat(propFullName, "' supplied to '").concat(componentName, "' Validation failed."));
};

var SubNavigation = function SubNavigation(_ref) {
  var children = _ref.children,
      onClick = _ref.onSelect;
  return React.createElement("div", {
    className: "SubNavigation"
  }, React.createElement("nav", {
    className: "main-subnav"
  }, Children.map(children, function (child) {
    return cloneElement(child, {
      onClick: onClick
    });
  })));
};

SubNavigation.displayName = 'SubNavigation';
SubNavigation.propTypes = {
  children: PropTypes.arrayOf(subNavigationPropTypes).isRequired,
  onSelect: PropTypes.func
};
export default SubNavigation;